import { motion } from "framer-motion";
import { Phone, Search, PenTool, Rocket } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export function HowWeIntegrateSection() {
  const { t } = useLanguage();

  const steps = [
    {
      number: "01",
      icon: Phone,
      title: t("howWeIntegrate.step.1.title"),
      description: t("howWeIntegrate.step.1.description"),
    },
    {
      number: "02",
      icon: Search,
      title: t("howWeIntegrate.step.2.title"),
      description: t("howWeIntegrate.step.2.description"),
    },
    {
      number: "03",
      icon: PenTool,
      title: t("howWeIntegrate.step.3.title"),
      description: t("howWeIntegrate.step.3.description"),
    },
    {
      number: "04",
      icon: Rocket,
      title: t("howWeIntegrate.step.4.title"),
      description: t("howWeIntegrate.step.4.description"),
    },
  ];

  return (
    <section id="how-we-work" className="py-20 lg:py-32 bg-card/30">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t("howWeIntegrate.title")}{" "}
            <span className="text-primary">{t("howWeIntegrate.titleHighlight")}</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t("howWeIntegrate.subtitle")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="card-surface p-6 hover-lift relative"
            >
              <span className="text-5xl font-display font-bold text-primary/15 absolute top-4 right-4">
                {step.number}
              </span>
              <div className="icon-box mx-auto mb-4 lg:mx-0">
                <step.icon className="w-6 h-6" />
              </div>
              <h3 className="font-semibold text-foreground mb-2 text-lg">
                {step.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
